




import React, { useEffect, useState } from "react";
import { Box, CircularProgress } from "@mui/material";
import { useMediaQuery } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import { BASE_URL } from "../../components/BASE_URL";
import { useTranslation } from "react-i18next";

const Privacy = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("lg"));
  const { i18n } = useTranslation();   // 👈 detect website language

  const [loading, setLoading] = useState(true);
  const [htmlContent, setHtmlContent] = useState("");

  useEffect(() => {
    async function fetchPolicy() {
      setLoading(true);
      try {
        const res = await fetch(`${BASE_URL}privacy-policy`, {
          method: "GET",
        });

        const json = await res.json();

        if (!json.error && json.data) {
          const selected =
            i18n.language === "es"
              ? json.data.content_es || json.data.content
              : json.data.content;

          setHtmlContent(selected || "");
        }
      } catch (error) {
        console.error("Error loading privacy policy:", error);
      } finally {
        setLoading(false);
      }
    }

    fetchPolicy();
  }, [i18n.language]);


  return (
    <Box sx={{ backgroundColor: "#F3F9FF", mt: isMobile ? 4: 4 }}>
      <Box sx={{ backgroundColor: "white", py: isMobile ? 6 : 6 }}>
        <Box sx={{ px: isMobile ? 2 : 4 }}>
          {loading ? (
            <Box
              sx={{
                minHeight: "40vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <CircularProgress />
            </Box>
          ) : (
            <div
              style={{
                fontFamily: "SF Pro Display, sans-serif",
                color: "#072533",
                fontSize: "16px",
                lineHeight: "1.8",
              }}
              dangerouslySetInnerHTML={{ __html: htmlContent }}
            />
          )}
        </Box>
      </Box>
    </Box>
  );
};

export default Privacy;
